<template>
    <v-card class="pa-5 text-center" elevation="1" height="100%">
        <div class="get-started-item">
            <div class="content-title my-3">{{ details.title }}</div>
            <div class="content-icon text-center mb-3" v-html="require(`!html-loader!@/assets/img/${details.icon}.svg`)"></div>
            <div class="content-description mb-3">
                <p>{{ details.description }}</p>
            </div>
            <span :class="['mb-3', { 'status-completed': details.status == 'Completed' }, { 'status-incomplete': details.status == 'Incomplete' }]">
                <v-icon v-if="details.status == 'Completed'">check</v-icon>
                {{ details.status == 'Completed' ? 'Completed!' : 'Incomplete' }}</span
            >
        </div>
    </v-card>
</template>

<script>
export default {
    name: 'GetStarted',
    props: {
        details: {
            type: Object,
            default: () => {}
        }
    }
};
</script>

<style lang="scss" scoped>
.get-started-item {
    .content-title {
        color: #16192c;
        font-weight: bold;
    }

    .content-icon {
        height: 90px;
    }

    .content-description {
        color: #425466;
        font-size: 14px;
    }
}

.status-completed,
.status-completed i {
    color: #5aad71;
    font-size: 16px;
    font-weight: bold;
}

.status-incomplete {
    color: #8492a6;
    font-weight: bold;
}
</style>
